import {callApi} from './serviceUtil.js'

export const loginApi = async (loginData) => {
    const url = loginData.url;
    const body = JSON.stringify(loginData.post_data);
    const headers = {
        "Content-Type": "application/json",
    }

    return await callApi({
        url: url,
        method: 'POST',
        headers : headers,
        body : body,
        auth : false
      });
};